module.exports = __webpack_public_path__ + "static/ctaBackground-c740a7996c3fce559e416f075dbb5c18.svg";